import {withParams} from 'vuelidate/lib/validators/common';

const req = value => {
  return value !== null;
};

export default withParams({type: 'required'}, req);